import type { ExcelImportRequest, ExcelImportResult, ExcelImportRowPayload } from '../../../../services/adminService';
import { importRecordsFromExcel } from '../../../../services/adminService';
import type { RecordExcelParseResult } from './recordExcelParser';

/** Пакеты импорта — меньше риск таймаута и перегрузки одним запросом. */
export const EXCEL_IMPORT_BATCH_SIZE = 400;

export function buildExcelImportRows(parseResult: RecordExcelParseResult): ExcelImportRowPayload[] {
  return parseResult.rows.map((row) => ({
    excelRowNumber: row.rowNumber,
    companyName: row.values.companyName || '',
    sectorName: row.values.sectorName || '',
    companyRoleName: row.values.companyRoleName || '',
    roleName: row.values.roleName,
    datacircleGrade: row.values.datacircleGrade,
    familyName: row.values.familyName,
    baseGrossSalary: row.values.baseGrossSalary,
    stiTargetPct: row.values.stiTargetPct,
    ltipForm: row.values.ltipForm,
  }));
}

export async function importExcelRowsInBatches(
  base: Omit<ExcelImportRequest, 'rows'>,
  rows: ExcelImportRowPayload[],
  onProgress?: (done: number, total: number) => void,
): Promise<ExcelImportResult> {
  if (rows.length === 0) {
    return { savedCount: 0, total: 0, saved: [], errors: [] };
  }

  let savedCount = 0;
  const errors: ExcelImportResult['errors'] = [];
  const saved: ExcelImportResult['saved'] = [];
  let errorsTruncated = false;
  let savedTruncated = false;

  for (let offset = 0; offset < rows.length; offset += EXCEL_IMPORT_BATCH_SIZE) {
    const chunk = rows.slice(offset, offset + EXCEL_IMPORT_BATCH_SIZE);
    const result = await importRecordsFromExcel({ ...base, rows: chunk });
    savedCount += result.savedCount;
    errors.push(...result.errors);
    saved.push(...result.saved);
    if (result.errorsTruncated) errorsTruncated = true;
    if (result.savedTruncated) savedTruncated = true;
    onProgress?.(Math.min(offset + chunk.length, rows.length), rows.length);
  }

  return {
    savedCount,
    total: rows.length,
    saved: saved.length <= 100 ? saved : saved.slice(0, 100),
    savedTruncated: savedTruncated || saved.length > 100,
    errors: errors.length <= 200 ? errors : errors.slice(0, 200),
    errorsTruncated: errorsTruncated || errors.length > 200,
  };
}
